import { render, staticRenderFns } from "./SGPGridComponent.vue?vue&type=template&id=3930116c&scoped=true"
import script from "./SGPGridComponent.vue?vue&type=script&lang=js"
export * from "./SGPGridComponent.vue?vue&type=script&lang=js"
import style0 from "./SGPGridComponent.vue?vue&type=style&index=0&id=3930116c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3930116c",
  null
  
)

export default component.exports